// /hooks/useInViewAnimations.js
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
	createInViewObserver,
	observeInViewElements,
	disconnectInViewObserver
} from './inViewObserverManager'

export function useInViewAnimations({
	rootMargin = '0px 0px -10% 0px',
	threshold = 0.15,
	once = true,
	enableMutationWatch = true
} = {}) {
	const location = useLocation()

	useEffect(() => {
		createInViewObserver({ rootMargin, threshold, once })

		// Initial scan after paint
		const raf = requestAnimationFrame(() => {
			observeInViewElements({ rootMargin, threshold, once })
		})

		let mo
		if (enableMutationWatch) {
			mo = new MutationObserver(() => {
				// defer to next frame for layout paint
				requestAnimationFrame(() => {
					observeInViewElements({ rootMargin, threshold, once })
				})
			})
			mo.observe(document.body, { childList: true, subtree: true })
		}

		return () => {
			cancelAnimationFrame(raf)
			if (mo) mo.disconnect()
			disconnectInViewObserver()
		}
	}, [rootMargin, threshold, once])

	// Re-scan on route change (new page content)
	useEffect(() => {
		// allow route content to mount
		const raf = requestAnimationFrame(() => {
			observeInViewElements({ rootMargin, threshold, once })
		})
		return () => cancelAnimationFrame(raf)
	}, [location, rootMargin, threshold, once])
}
